import { ROLE_LABELS } from '../../models/enums/roleLabels';

export const ROLES = ROLE_LABELS;
